export default {
  methods: {
    baseHasDismissedTip (key) {
      return this.$store.getters['tips/hasDismissedTip'](key)
    },
    async baseDismissTip (key) {
      await this.$post('v1/tips/dismiss', {
        key
      })
    }
  }
}
